import { useSubscription } from "@apollo/client";
import { Row } from "antd";
import { useState, useEffect } from "react";

import { EdgeSensorData, EdgeSensorDataDocument } from "@src/graphql/graphql";

import SensorGraph from "./SensorGraph";
import { getGraphColorByIndex } from "./utils";

interface SensorGraphsProps {
  assetId: string;
}

const SensorGraphs = ({ assetId }: SensorGraphsProps) => {
  const [sensorDataMap, setSensorDataMap] = useState<
    Record<string, EdgeSensorData>
  >({});

  const { data } = useSubscription(EdgeSensorDataDocument, {
    variables: { assetId },
  });

  useEffect(() => {
    const edgeSensorData = data?.edgeSensorData;
    const name = edgeSensorData?.name;

    if (edgeSensorData && name) {
      setSensorDataMap((prevMap) => ({
        ...prevMap,
        [name]: edgeSensorData,
      }));
    }
  }, [data]);

  return (
    <Row gutter={20}>
      {Object.entries(sensorDataMap)
        .sort(([nameA], [nameB]) => nameA.localeCompare(nameB))
        .map(([name, data], index) => (
          <SensorGraph
            key={name}
            name={name}
            latestData={data}
            color={getGraphColorByIndex(index)}
          />
        ))}
    </Row>
  );
};

export default SensorGraphs;
